// extracted by mini-css-extract-plugin
module.exports = {"side-nav-item":"SideNavigationItem_side-nav-item__AP7ju","selected":"SideNavigationItem_selected__cdUtX"};